import React, {useEffect, useMemo, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import Styles from './index.module.scss'
import NFTModal from "@/components/NFTModal";
import ActivityRules from "../components/ActivityRules";
import Service from "../service"
import {hideLoading, showLoading} from "@/components/loading";
import {Toast} from "antd-mobile";
import {objectToQueryParams} from "@/utils/publicFun";
import ListView from "@/components/AntListView";

/**
 * @description 江苏文交所二期
 * @return {/culturalExchange_gold/collectionRecord}
 */

const CollectionRecord = () => {
  const navigate = useNavigate();
  const [records, setRecords] = useState([])
  const [hasMore, setHasMore] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const currentPage = useRef(1);
  const pageSize = useRef(10);
  const [addinit, setAddinit] = useState({});

  useEffect(() => {
    (()=>{
      // 临时假数据用于展示
      // const mockData = [
      //   {
      //     id: 1,
      //     status: 2, // 已通过
      //     userName: '何薇',
      //     applyTime: '2026.12.01 12:00:00',
      //     quantity: '5',
      //     fee: '10000.00',
      //     approvalTime: '2026.12.01 12:00:00'
      //   },
      //   {
      //     id: 2,
      //     status: 1, // 审核中
      //     applyTime: '2026.12.01 12:00:00',
      //     quantity: '5',
      //     fee: '10000.00'
      //   },
      //   {
      //     id: 3,
      //     status: 2, // 已通过
      //     userName: '张三',
      //     applyTime: '2026.11.28 14:30:00',
      //     quantity: '10',
      //     fee: '20000.00',
      //     approvalTime: '2026.11.29 09:15:00'
      //   },
      //   {
      //     id: 4,
      //     status: 1, // 审核中
      //     applyTime: '2026.11.30 16:20:00',
      //     quantity: '3',
      //     fee: '6000.00'
      //   }
      // ];
      // setRecords(mockData);
      // setIsLoad(true);
      // setHasMore(false);
      getData(true);
      onDidFocus();
    })()

  }, []);

  // 监听页面获得焦点，返回时刷新列表
  const onDidFocus = () => {
    window.JsBridge.addListener().then(() => {
      getData(true, true);
      onDidFocus();
    });
  }

  const getData = async (loading = false, isRefresh = true) => {
    try {
      if (loading) showLoading();

      const addinitRes = await Service.getAddInit();
      console.log('addinit===>', addinitRes)
      setAddinit(addinitRes.data);
      
      if (isRefresh) {
        currentPage.current = 1;
      } else {
        currentPage.current = currentPage.current + 1;
      }
      
      const res = await Service.getApprovalList(currentPage.current);
      if (loading) hideLoading();
      if(res?.data?.list?.length > 0){
        const newList = res.data.list || [];
        if (currentPage.current === 1) {
          setRecords(newList);
        } else {
          setRecords([...records, ...newList]);
        }
        console.log('newList===>', newList)
        setIsLoad(true);
        setHasMore(newList.length >= pageSize.current);
      } else {
        setIsLoad(true);
        setHasMore(false);
      }
    } catch (error) {
      hideLoading();
      Toast.show(error);
    }
  }

  const loadMore = async () => {
    await getData(false, false);
  }

  const onRefresh = async () => {
    await getData(false, true);
  }

  const handleItemClick = (item) => {
    const url = `/culturalExchange_taijigreencarbon/applyDetail`;
    // 通过 state 传递数据
    navigate(url, { state: { recordData: item } });
  }

  const RecordItem = (item, index) => {
    // 状态：0:待审核 1:审核通过 2:审核拒绝
    const status = item.status || 0;
    const isApproved = status === 1;
    
    return (
      <div 
        key={item.id} 
        className={Styles.recordCard}
        onClick={() => handleItemClick(item)}
      >
        
        <div className={Styles.itemInfo}>
          <div className={Styles.infoRow}>
            <span className={Styles.label}>申请时间</span>
            <span className={Styles.value}>{item.createTime || ''}</span>
          </div>
          <div className={Styles.divider}></div>
          
          <div className={Styles.infoRow}>
            <span className={Styles.label2}>数量</span>
            <span className={Styles.value2}>{item.num || 0}T</span>
          </div>
          
          <div className={Styles.infoRow}>
            <span className={Styles.label2}>手续费</span>
            <span className={Styles.value2}>¥{item.fees || 0}{item.usePoint>0?'及'+item.usePoint+'积分':''}</span>
          </div>
          <div className={Styles.divider}></div>
          
          <div className={Styles.infoRow}>
            <span className={Styles.label3}>申请状态:</span>
            <span className={`${Styles.value3} ${Styles.statusText} ${isApproved ? Styles.approved : Styles.reviewing}`}>
              {status === 1 ? '已通过' : status === 2 ?'审核拒绝':'审核中'}
            </span>
          </div>
          
          {/* 已通过状态显示通过时间 */}
          {isApproved && item.optTime && (
            <div className={Styles.infoRow}>
              <span className={Styles.label3}>通过时间:</span>
              <span className={Styles.value4}>{item.optTime}</span>
            </div>
          )}
        </div>
        
        {/* 已通过状态显示提示信息 */}
        {isApproved && (
          <div className={Styles.tipText}>
            审核通过后10个工作日内完成碳信用转移,且<span className={Styles.highlightText}>藏品被回收</span>
          </div>
        )}
      </div>
    )
  }

  const handleBack = () => {
    if (window.JsBridge.hasWebViewBridge()) {
        window.JsBridge.back();
      } else {
        navigate(-1);
      }
      // navigate(-1);
  }

  const handleAddApply = (item) => {
    const url = `/culturalExchange_taijigreencarbon/addApply`;
    // if (window.JsBridge.hasWebViewBridge()) {
    //   window.JsBridge.push("CustomWeb", { uri: `${window.location.origin}${url}` });
    // } else {
      navigate(url, { state: { recordData: item } });
    // }
  }

  return (
    <div className={Styles.collectionRecord}>
      {/* 状态栏 */}
      <div className={Styles.statusBar}>
      </div>

      {/* 导航栏 */}
      <div className={Styles.navBar}>
        <div className={Styles.backButton} onClick={handleBack}>
        </div>
        <div className={Styles.title}>我的申请</div>
        <div className={Styles.placeholder} onClick={() => handleAddApply(addinit)}>新增申请</div>
      </div>

      <div className={Styles.titleBox}>当前可申请数量：{addinit?.maxNum || 0}T</div>

      {/* 内容区域 */}
      <div className={Styles.content}>
        <ListView
          dataSource={records}
          hasMore={hasMore}
          renderItem={RecordItem}
          onRefresh={onRefresh}
          onEndReached={loadMore}
          isLoad={isLoad}
          emtyDesc="暂无领取记录"
        />
      </div>
    </div>
  )
}

export default CollectionRecord
